import type { InputHTMLAttributes, ReactNode } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  leadingIcon?: ReactNode;
}

export function Input({ label, hint, leadingIcon, required, className = '', ...rest }: InputProps) {
  const control = (
    <div className="tr-field__control">
      {leadingIcon}
      <input className="tr-input" required={required} {...rest} />
    </div>
  );
  if (!label) return control;
  return (
    <label className={`tr-field ${className}`.trim()}>
      <span className="tr-field__label">
        {label}
        {required && <span className="tr-field__req">*</span>}
      </span>
      {control}
      {hint && <span className="tr-field__hint">{hint}</span>}
    </label>
  );
}
